import { NgModule } from '@angular/core';
import { DefaultAvatarPipe } from './default-avatar.pipe';

@NgModule({
	declarations: [DefaultAvatarPipe],
	exports: [DefaultAvatarPipe]
})
export class PipesModule { }
